import React, { useEffect } from 'react'
import type { ReactNode } from 'react'
import classNames from 'classnames'
import { isDesktopDevice, isIOSDevice } from 'mobile_web/modules/platform/device'

// A tap outside any input blurs what kept the focus, as Ionic's input blurring did on iOS touch devices.
const startInputBlurring = (): (() => void) => {
	const SKIP = 'input, textarea, [no-blur], [contenteditable]'
	let focused = true
	const onFocusin = () => {
		focused = true
	}
	const onTouchend = (event: TouchEvent) => {
		const active = document.activeElement as HTMLElement | null
		const tapped = event.target as HTMLElement
		if (!active || active.matches(SKIP) || tapped === active || tapped.closest(SKIP)) return
		focused = false
		setTimeout(() => {
			if (!focused) active.blur()
		}, 50)
	}
	document.addEventListener('focusin', onFocusin, true)
	document.addEventListener('touchend', onTouchend, false)
	return () => {
		document.removeEventListener('focusin', onFocusin, true)
		document.removeEventListener('touchend', onTouchend, false)
	}
}

interface Props {
	className?: string
	children?: ReactNode
}

// The app's full-screen root, which modals mount into, as <ion-app> was.
const AppShell: React.FC<Props> = ({ className, children }) => {
	useEffect(() => (isIOSDevice() && !isDesktopDevice() ? startInputBlurring() : undefined), [])

	return <div className={classNames('app-shell', 'ion-page', className)}>{children}</div>
}

export default AppShell
